import * as Yup from 'yup'

export const tradeValidationSchema = Yup.object().shape({
  principal: Yup.number().required(),
  coupon: Yup.number().required(),
  allocationCode: Yup.string().required(),
  purchaseDate: Yup.date().required(),
  maturityDate: Yup.date().required(),
  note: Yup.string().nullable(),
  reference: Yup.string().nullable(),
  bankReference: Yup.string().nullable(),
})

export const managedFundValidationSchema = Yup.object().shape({
  quantityToKeep: Yup.number().required(),
  price: Yup.number().required(),
  transactionDate: Yup.date().nullable(),
  note: Yup.string().nullable(),
  reference: Yup.string().nullable(),
  bankReference: Yup.string().nullable(),
})
